export default __webpack_public_path__ + "resources/icons/n431-1bd9.png";